import useLanguage from '../hooks/useLanguage';
import useResponsiveFlags from '../hooks/useResponsiveFlags';
import DeviceMobile from './DeviceMobile';
import { translations } from '../locales/lang';

import styles from '../assets/styles/DeviceSection.module.css';

export default function DeviceSection() {
    const { isMobile, isTablet } = useResponsiveFlags();
    const { language } = useLanguage();
    return (
        <section className={styles.section} id="device">
            {
                isMobile ? (
                    <DeviceMobile />
                ) :
                    (<>
                        <div className={styles.containerTitle}>
                            <h2 className={styles.title}>{translations[language].device.title}</h2>
                            <p className={styles.subtitle}>
                                {translations[language].device.desc}
                            </p>
                        </div>

                        <div className={styles.container}>
                            <div className={`${styles.column} ${styles.columnLeft}`}>
                                <div className={styles.containerInfo} >
                                    <h3 className={styles.columnTitle} data-aos="fade-right">{translations[language].device.web.title}</h3>
                                    <div className={styles.columnContent}>
                                        <p className={styles.description} data-aos="fade-right" dangerouslySetInnerHTML={{ __html: translations[language].device.web.desc }} />
                                        <ul className={styles.featureList} data-aos="fade-right">
                                            <li>{translations[language].device.web.features[0]}</li>
                                            <li>{translations[language].device.web.features[1]}</li>
                                            <li>{translations[language].device.web.features[2]}</li>
                                        </ul>
                                    </div>
                                </div>
                                {isTablet && <div className={styles.images}>
                                    <img src='/images/device/laptop.png' alt="Device" className={styles.laptop} data-aos="fade" />
                                </div>}
                            </div>

                            {
                                !isTablet &&
                                <div className={styles.images} style={{ position: 'relative', width: '633px', height: '551px' }}>
                                    {/* <img src='/images/device/device.png' alt="Device" /> */}
                                    <img
                                        data-aos="fade"
                                        data-aos-delay="600"
                                        src='/images/device/laptop.png' alt="Device"
                                        className={styles.laptop}
                                    />
                                    <img
                                        data-aos="fade"
                                        data-aos-delay="600"
                                        src='/images/device/phone.png' alt="Device"
                                        className={styles.phone}
                                    />
                                </div>
                            }

                            <div className={`${styles.column} ${styles.columnRight}`}>
                                {isTablet && <div className={styles.images}>
                                    <img src='/images/device/phone.png' alt="Device" className={styles.phone} data-aos="fade" />
                                </div>}
                                <div className={styles.storesContainer}>
                                    <div className={styles.stores} data-aos="fade-left">
                                        <div className={styles.qrCode}>
                                            <img src="/images/device/qr-code.png" alt="qr-code" style={{ width: '93px', height: 'auto', objectFit: 'contain' }} />
                                        </div>
                                        <div className={styles.storesList}>
                                            <img src="/images/device/app-store.png"
                                                alt="App Store"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => { window.open("https://apps.apple.com/id/app/lcms-i-school/id6747659818", "_blank") }} />
                                            <img src="/images/device/ch-play.png"
                                                alt="Google Play"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => { window.open("https://play.google.com/store/apps/details?id=com.dtp.ischool&hl=en", "_blank") }} />
                                        </div>
                                    </div>
                                    <div className={styles.containerInfo}>
                                        <h3 className={styles.columnTitle} data-aos="fade-left">{translations[language].device.mobile.title}</h3>
                                        <div className={styles.columnContent}>
                                            <p className={styles.description} data-aos="fade-left" dangerouslySetInnerHTML={{ __html: translations[language].device.mobile.desc }} />
                                            <ul className={styles.featureList} data-aos="fade-left">
                                                <li>{translations[language].device.mobile.features[0]}</li>
                                                <li>{translations[language].device.mobile.features[1]}</li>
                                                <li>{translations[language].device.mobile.features[2]}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>)
            }
        </section>
    );
}
